import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/functions'


//import fb from 'firebase'

Vue.use(firestorePlugin)

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyDuldz0hoB31Jc3LVgh3KjWUy2I5gbuygM',
  authDomain: 'foober-ced85.firebaseapp.com',
  databaseURL: 'https://foober-ced85.firebaseio.com',
  projectId: 'foober-ced85',
  storageBucket: 'foober-ced85.appspot.com',
  messagingSenderId: '204259685191'
}
export const firebaseApp = firebase.initializeApp(config)
export const auth = firebase.auth()
export const db = firebase.firestore()
export const fb = firebase
export const fbFunctions = firebase.functions()
export const apiKey = config.apiKey
//firebaseApp.auth()
//fb.auth()



// WEBPACK FOOTER //
// ./src/firebase.js